<template>
    <div>
        <p class="timeline-talks">{{ message }}</p>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        message() {
            if (this.details) {
                return (
                    'Profile has been viewed by ' +
                    this.details.user.firstName +
                    ' ' +
                    this.details.user.lastName +
                    '.'
                )
            }
            return ''
        },
    },
}
</script>
